import script from "./DebugFlyout.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugFlyout.vue?vue&type=script&setup=true&lang=js"

import "./DebugFlyout.vue?vue&type=style&index=0&id=2f967d8b&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f967d8b"]])

export default __exports__